import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { jwtDecode as decode } from 'jwt-decode';
import createRootReducer from './reducers';
import { rehydrateToken } from './middleware/rehydrateToken';

const getPreloadedState = () => {
  try {
    const token = localStorage.getItem('sessionToken');
    if (!token) return undefined;

    const decoded = decode(token);
    if (Date.now() / 1000 > decoded.exp) {
      localStorage.removeItem('sessionToken');
      return undefined;
    }

    const { payload } = decoded;
    const { role, system, id, distributorId, status } = payload;
    return { auth: { token, role, system, id, distributorId, status } };
  } catch {
    return undefined;
  }
};

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const enhancer = composeEnhancers(applyMiddleware(rehydrateToken, thunk));
const store = createStore(createRootReducer(), getPreloadedState(), enhancer);

export default store;
